import { render, staticRenderFns } from "./logisticsSearch.vue?vue&type=template&id=6a2f8520&scoped=true&"
import script from "./logisticsSearch.vue?vue&type=script&lang=js&"
export * from "./logisticsSearch.vue?vue&type=script&lang=js&"
import style0 from "./logisticsSearch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./logisticsSearch.vue?vue&type=style&index=1&id=6a2f8520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f8520",
  null
  
)

export default component.exports